var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_9161)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1410_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42969 5.71411L10.0011 9.28554L13.5725 5.71411",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.002 0.714111V9.28554",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.144 6.42847C17.5228 6.42847 17.8863 6.57898 18.1541 6.84688C18.422 7.1148 18.5725 7.47815 18.5725 7.85704V17.857C18.5725 18.2359 18.422 18.5993 18.1541 18.8672C17.8863 19.135 17.5228 19.2856 17.144 19.2856H2.85826C2.47937 19.2856 2.11602 19.135 1.8481 18.8672C1.5802 18.5993 1.42969 18.2359 1.42969 17.857V7.85704C1.42969 7.47815 1.5802 7.1148 1.8481 6.84688C2.11602 6.57898 2.47937 6.42847 2.85826 6.42847",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42969 8.22852L10.0011 14.2856L18.5725 8.22852",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1410_9161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.71af4f40c7f0bd161a83ac452dc19eb7.svg";
export { ForwardRef as ReactComponent };